function getTitle (vm) {
  const {pageTitle} = vm
  if (pageTitle) {
    return typeof pageTitle === 'function'
      ? pageTitle.call(vm)
      : pageTitle
  }
}

export default {
  created () {
    const title = getTitle(this)
    let baseTitle = (this.$store && this.$store.state.appSettings.baseWebTitle) || 'TITULO NO DEFINIDO'

    document.title = baseTitle + (title ? (' - ' + title) : '')
  }
}



// WEBPACK FOOTER //
// ./src/mixins/titleMixin.js